
import Vue from 'vue';
import cloneDeep from 'clone-deep';
import {saveAs} from 'file-saver';

import * as Api from '@/api';

import { BLSearchResult } from '@/types/blacklabtypes';
import * as UIStore from '@/store/search/ui';
import * as CorpusStore from '@/store/search/corpus';
import { debugLog } from '@/utils/debug';
import { ensureCompleteFieldName } from '@/utils';
import { corpusCustomizations } from '@/utils/customization';

export default Vue.extend({
	props: {
		results: Object as () => BLSearchResult,
		type: String as () => 'hits'|'docs',
		annotations: Array as () => string[],
		metadata: Array as () => string[],

		disabled: Boolean
	},
	data: () => ({
		downloadInProgress: false,
	}),
	computed: {
		spanAttributesToExport(): string[] {
			const spans = Object.entries(CorpusStore.getState().corpus?.relations.spans || {});
			return spans.flatMap(([spanName, spanInfo]) =>
				Object.keys(spanInfo.attributes || {})
					.map(attrName => [ spanName, attrName ])
					.filter(([spanName, attrName]) => corpusCustomizations.results.export.includeSpanAttribute(spanName, attrName))
						.map(([spanName, attrName]) => `${spanName}.${attrName}`)
				);
		}
	},
	methods: {
		downloadCsv(excel: boolean) {
			if (this.downloadInProgress || !this.results) {
				return;
			}

			this.downloadInProgress = true;
			const apiCall = this.type === 'hits' ? Api.blacklab.getHitsCsv : Api.blacklab.getDocsCsv;
			const params = cloneDeep(this.results.summary.searchParam);
			if (this.annotations) params.listvalues = this.annotations!.join(',');
			if (this.metadata) params.listmetadatavalues = this.metadata.join(',');
			params.listspanattributes = this.spanAttributesToExport.join(',');
			(params as any).csvsepline = !!excel;
			(params as any).csvsummary = true;
			const fieldDisplayName = (name: string, baseFieldName: string = '') => {
				const defaultField = this.results.summary.pattern?.fieldName ?? CorpusStore.get.mainAnnotatedField();
				name = ensureCompleteFieldName(name, defaultField); // don't just pass version name
				return this.$td(`index.annotatedFields.${name}`, name);
			}
			(params as any).csvdescription = corpusCustomizations.results.export.description(this.results.summary, fieldDisplayName) || '';

			debugLog('starting csv download', this.type, params);
			apiCall(INDEX_ID, params).request
			.then(
				blob => saveAs(blob, 'data.csv'),
				error => debugLog('Error downloading csv file', error)
			)
			.finally(() => this.downloadInProgress = false);
		},
	}
})
